module.exports = __webpack_public_path__ + "assets/wu.480efcd5.svg";